import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // console.log("autocomplete events controller connect!!", this.element);

    this.changeHandler = this.handleChange.bind(this);
    this.element.addEventListener("autocomplete.change", this.changeHandler);
    // const events = [
    //   "autocomplete.change",
    //   "loadstart",
    //   "load",
    //   "error",
    //   "loadend",
    //   "toggle",
    // ];

    // events.forEach((eventType) => {
    //   autocomplete.addEventListener(eventType, (event) => {
    //     console.log(`${eventType} event emitted`, event);
    //   });
    // });
    //
  }

  disconnect() {
    this.element.removeEventListener("autocomplete.change", this.changeHandler);
  }

  handleChange(event) {
    console.log(event);

    $.post(event.target.dataset.autocompleteChangeUrl, {
      artist_id: event.detail.value,
      inline: true,
    });
  }
}
